import { NoNetworkIcon } from '@blocksuite/icons/rc';
import type { ReactNode } from 'react';

import type { PageStatusBannerTone } from './page-status-banner';

export interface PageStatusNotice {
  ariaLive?: 'assertive' | 'off' | 'polite';
  children: ReactNode;
  collapsible?: boolean;
  icon?: ReactNode;
  id: string;
  role?: string;
  size?: 'normal' | 'compact';
  title?: string;
  tone: PageStatusBannerTone;
}

export function createOfflineStatusNotice(
  children: ReactNode,
  options: {
    id?: string;
    size?: 'normal' | 'compact';
    title?: string;
  } = {}
): PageStatusNotice {
  return {
    id: options.id ?? 'offline',
    tone: 'warning',
    role: 'status',
    ariaLive: 'polite',
    size: options.size ?? 'compact',
    title: options.title,
    icon: <NoNetworkIcon style={{ fontSize: 16 }} />,
    children,
  };
}
